import jwt_decode from "jwt-decode";
const defaultUserState = () => {
    return {
        token: null,
        infos: { hasAcceptedTerms: true },
        accessLevel: null,
        type: null,
        companyType: null,
        isDownloadLoading: false,
        loading: false,
        cnpjsLength: null,
        cnpjId: null,
        companys: [],
        cnpj: null,
        buyerSponsor: false,
        companyUsers: [],
        mainBank: false,
        cashforceBank: false,
        registerComplete: false,
        availableToMarketplace: false,
        availableToFomentation: false,
        availableToXmlAnticipation: false,
        availableToRequestValueForAnticipation: false,
        availableToImportWorksheet: false,
        orderAntecipationMode: false,
        verificationCode: null,
        questionsNotAnswered: { marketplace: 0, fomentation: 0},
        registerPercentage: 100,
        availableOffers: { marketplace: 0, fomentation: 0},
        onboarding: {
            requestFomentation: false,
            requestAntecipation: false,
            acceptProposal: false,
            seeOpportunities: false,
            makeProposal: false,
            closeProposal: false,
            coachFinancialPosition: false,
            coachCreditFomentation: false,
            coachCreditAntecipation: false,
            coachProposalFomentation: false,
            coachProposalAntecipation: false,
            coachOpportunitiesFomentation: false,
            coachOpportunitiesAntecipation: false,
        },
        calculateStepsRegister: {},
        allUsers: [],
        usersPagination: {},
        partnerAdm: false,
        canOperate: false,
        openRequestsAnticipation: 0,
        openValidations: 0,
        haveRequestsAnticipation: 0,
        notifications: {
            billing: 0,
        },
        showReceivableTab: []
    }
}
export default {
    namespaced: true,
    state: defaultUserState(),
    mutations: {
        setVerificationCode(state, verificationCode) {
            Object.assign(state, { verificationCode });
        },
        setProfile(state, type) {
            Object.assign(state, { type });
        },
        setRules(state, { mainBank, cashforceBank, registerComplete, registerStep, availableToMarketplace, availableToFomentation, orderAntecipationMode, registerPercentage, calculateStepsRegister, availableToXmlAnticipation, availableToBalanceAnticipation, canOperate, openValidations, availableToRequestValueForAnticipation, openRequestsAnticipation, availableToImportWorksheet, haveRequestsAnticipation, showReceivableTab}) {
            let processedShowReceivableTab = []

            if (showReceivableTab && Array.isArray(showReceivableTab)) {
                processedShowReceivableTab = showReceivableTab.map(item => ({
                    ...item,
                    showReceivableTab: item.showReceivableTab !== undefined ? item.showReceivableTab : true
                }));
            } else {
                processedShowReceivableTab = [{ showReceivableTab: true }];
            }
            
            Object.assign(state, { mainBank, cashforceBank, registerComplete, registerStep, availableToMarketplace, availableToFomentation, orderAntecipationMode, registerPercentage, calculateStepsRegister, availableToXmlAnticipation, availableToBalanceAnticipation, canOperate, openValidations, availableToRequestValueForAnticipation, openRequestsAnticipation, availableToImportWorksheet, haveRequestsAnticipation, showReceivableTab: processedShowReceivableTab});
        },
        setToken(state, token) {
            const { userAdm, cnpj, accessLevel, cnpjsLength, cnpjId, registerComplete, companyType, partnerAdm, canOperate } = jwt_decode(token);

            Object.assign(state, { token, accessLevel, cnpj, userAdm, cnpjsLength, cnpjId, registerComplete, companyType, partnerAdm, canOperate });
        },
        setInfo(state, info) {
            if (info.length) {
                const { id } = jwt_decode(state.token);
                let user = info.find((user) => {
                    return user.id == id
                })
                info = user
            }
            const { name, email, userAdm, cpf, phoneNumber, hasAcceptedTerms } = info;
            Object.assign(state, { infos: { name, email, userAdm, cpf, phoneNumber, hasAcceptedTerms } });
        },
        setInfoSignUp(state, token) {
            const { name, email, cpf, phoneNumber } = jwt_decode(token);
            
            Object.assign(state, { infos: { name, email, cpf, phoneNumber, hasAcceptedTerms: true }, token });
        },
        setType(state, type) {
            Object.assign(state, { type });
        },
        setCnpj(state, cnpj) {
            Object.assign(state, { cnpj });
        },
        setIsDownloadLoading(state, isDownloadLoading) {
            Object.assign(state, { isDownloadLoading });
        },
        setLoading(state, loading) {
            Object.assign(state, { loading });
        },
        setCompanys(state, companys) {
            Object.assign(state, { companys });
        },
        setCompanyUsers(state, companyUsers) {
            Object.assign(state, { companyUsers });
        },
        resetState(state) {
            Object.assign(state, defaultUserState())
        },
        setOnboarding(state, onboarding) {
            Object.assign(state, { onboarding } )
        },
        setUsersPagination(state, usersPagination) {
            Object.assign(state, { usersPagination });
        },
        setAllUsers(state, allUsers) {
            Object.assign(state, { allUsers });
        },
        setAvailableOffersMarketplace(state, marketplace) {
            Object.assign(state, { availableOffers: { ...state.availableOffers, marketplace } } )
        },
        setQuestionsNotAnsweredMarketplace(state, marketplace) {
            Object.assign(state, { questionsNotAnswered: { ...state.questionsNotAnswered, marketplace } })
        },
        setAvailableOffersFomentation(state, fomentation) {
            Object.assign(state, { availableOffers: { ...state.availableOffers, fomentation } } )
        },
        setQuestionsNotAnsweredFomentation(state, fomentation) {
            Object.assign(state, { questionsNotAnswered: { ...state.questionsNotAnswered, fomentation } })
        },
        setMainBank(state, mainBank) {
            Object.assign(state, { mainBank });
        },
        setNotificationBilling: (state, newValue) => state.notifications.billing = newValue,
    },
    actions: {}
}